module.exports = ".yeti-modal-content {\n  text-align: center; }\n\n@media screen and (max-width: 375px) {\n  .yeti-icon-close {\n    margin-left: 30px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/modal-dialog/modal-dialog.component.scss
// module id = 635
// module chunks = 0